import type { FC, ReactNode } from 'react';

import { PAGE_CONFIG } from 'pages/page-config';

interface MainLayoutProps {
  formKey: string;
  children: ReactNode;
}

const MainLayout: FC<MainLayoutProps> = ({ formKey, children }) => {
  const { Layout } = PAGE_CONFIG[formKey];

  return <Layout>{children}</Layout>;
};

export { MainLayout };
